import styled from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import { customStyles as cancelModalCustomStyles } from '../../screens/Home/Components/OrderDetails/Components/CancelModal/style';

export const customStyles = {
  ...cancelModalCustomStyles,
  content: {
    ...cancelModalCustomStyles.content,
    padding: '20px',
    overflow: 'initial !important',
  },
};

export const inputCustomStyles = {
  padding: '10px',
  textAlign: 'center',
};

export const Container = styled.form`
  ${mixins.flexPosition({ direction: 'column' })}
  height: 100%;
  position: relative;
`;

export const Title = styled.h3`
  ${mixins.fontStyle(styles.colors.GRAY_DARKER, styles.fontSizes.SIZE_5, styles.fontWeights.NORMAL)}
  line-height: 22px;
  margin-bottom: 10px;
`;

export const Content = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const Footer = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
  margin-top: 20px;
  width: 100%;
`;

export const Section = styled.div`
  border: 1px solid ${styles.colors.GRAY_LIGHT_2};
  border-radius: 3px;
  padding: 0 10px;
  width: 100%;

  &:last-child {
    margin-left: 10px;
  }
`;

export const SectionHeader = styled.div`
  border-bottom: 1px solid ${styles.colors.GRAY_LIGHT_2};
  ${mixins.fontStyle(
    styles.colors.GRAY_DARKER,
    styles.fontSizes.SIZE_6,
    styles.fontWeights.SEMIBOLD
  )}
  ${mixins.flexPosition({ align: 'center' })}
  line-height: 25px;
  padding: 15px 5px;

  > svg {
    margin-right: 10px;
  }
`;

export const SectionContent = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  padding: 20px 10px;

  > div:first-child {
    flex-shrink: 0;
  }
`;

export const ErrorMessage = styled.div`
  background-color: ${styles.colors.DANGER_COLOR};
  border-radius: 5px;
  ${mixins.flexPosition({ align: 'center' })}
  ${mixins.fontStyle(
    styles.colors.WHITE,
    styles.fontSizes.SIZE_7,
    styles.fontWeights.SEMIBOLD
  )}
  height: 40px;
  margin: 0 20px;
  padding: 5px 15px;
  width: 100%;

  > svg {
    margin-right: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/TimeModal/style.js